<template>
  <g
    :class="CompletionClass"
    class="RelationCompletion"
  >
    <rect
      class="line background"
      :x="x"
      :y="y"
      :width="width"
      :height="height"
      :rx="r"
      :ry="r"
    />
    <rect
      class="line"
      :x="line.x"
      :y="line.y"
      :width="line.width"
      :height="line.height"
      :rx="r"
      :ry="r"
    />
  </g>
</template>

<script>
  export default {
    props: {
      x: {
        type: Number,
        required: true,
      },
      y: {
        type: Number,
        required: true,
      },
      r: {
        type: Number,
        default: 2,
      },
      width: {
        type: Number,
        default: 300,
      },
      height: {
        type: Number,
        default: 200,
      },
      completion: {
        type: Number,
        required: true,
      },
    },
    computed: {
      CompletionClass() {
        if (this.completion >= 100) {
          return 'RelationCompletion--success'
        }
        if (this.completion >= 40) {
          return 'RelationCompletion--warning'
        }

        return 'RelationCompletion--error'
      },
      line() {
        const width = (this.width * this.completion) / 100

        return {
          x: this.x,
          y: this.y,
          width,
          height: this.height,
        }
      },
    },
  }
</script>

<style scoped lang="scss">
$success: $color-00d367;
$warning: $color_f6a60f;
$error: $color_ea3b38;

.RelationCompletion {
  $root: &;

  & .background {
    opacity: 0.16;
  }

  &--success .line {
    fill: $success;
  }
  &--warning .line {
    fill: $warning;
  }
  &--error .line {
    fill: $error;
  }
}
</style>
